import React from 'react'
import { AppContainer } from '../AppContainer/AppContainer'
import { AppWithConfigurationHOC, AppWithConfigurationProps } from './AppHOC'

export const DrawerApp: React.FC<AppWithConfigurationProps> = props => {
  const { customerContext: customer, actionModule, environment, widgetContext } = props
  return (
    <AppWithConfigurationHOC
      customerContext={customer}
      environment={environment}
      actionModule={actionModule}
      widgetContext={widgetContext}
    >
      <AppContainer />
    </AppWithConfigurationHOC>
  )
}
